import React from 'react';

import { Modal } from 'antd';
// eslint-disable-next-line import/no-unresolved
import EasyVirtualizedScroller from 'easy-react-virtualized';
import moment from 'moment';

import Header from '../../../components/Header/Header';
import {
  IPollVoteByUser,
  PollOption,
} from '../../../types/communityMessagesTypes';
import CommunityUserCard from './CommunityUserCard';

type Props = {
  showModal: boolean;
  closeModal: () => void;
  question: string;
  pollOptions: PollOption[];
  selectedOption: string;
  setSelectedOption: (option: string) => void;
  userList: IPollVoteByUser[];
  totalPollVotes: number;
  fetchUserList: () => Promise<void>;
  hasMore: boolean;
};

const PollVotedUserListModal: React.FC<Props> = ({
  showModal,
  closeModal,
  question,
  pollOptions = [],
  selectedOption,
  setSelectedOption,
  userList,
  totalPollVotes,
  fetchUserList,
  hasMore,
}) => {
  const trimOption = (option: string) => {
    if (option?.length > 30) {
      return `${option.slice(0, 30)}...`;
    }
    return option;
  };

  return (
    <Modal
      open={showModal}
      title={null}
      footer={null}
      closable={false}
      destroyOnClose
      className="full-page-model poll-voted-user-list-modal">
      <div>
        <div>
          <Header
            title={`Poll Votes`}
            backType="arrow"
            handleBack={closeModal}
          />
        </div>
        <div className="poll-voted-user-list-modal_container">
          <div className="poll-voted-user-list-modal_container_question">
            <p>{question}</p>
          </div>
          <div className="poll-voted-user-list-modal_container_user-list">
            <div className="poll-voted-user-list-modal_container_user-list_filter">
              <p>Filter by poll option</p>
              <div className="poll-voted-user-list-modal_container_user-list_filter_buttons">
                <button
                  className={`${selectedOption === 'all' ? 'selected' : ''}`}
                  onClick={() => {
                    setSelectedOption('all');
                  }}>
                  All
                </button>
                {pollOptions.map((option) => (
                  <button
                    className={`${
                      selectedOption === option?.optionId ? 'selected' : ''
                    }`}
                    key={option?.optionId}
                    onClick={() => {
                      setSelectedOption(option?.optionId);
                    }}>
                    {trimOption(option?.optionContent)}
                  </button>
                ))}
              </div>
            </div>
            <div>
              <p>Voted Users ({totalPollVotes})</p>
              <EasyVirtualizedScroller
                useParentScrollElement
                key={question + moment().toISOString()}
                hasMore={hasMore}
                onLoadMore={() => fetchUserList()}>
                {userList.map((user) => (
                  <div key={user._id}>
                    <CommunityUserCard
                      user={{ ...user, profilePicType: 'image' }}
                      isClickable={false}
                      onClick={() => {}}
                    />
                  </div>
                ))}
              </EasyVirtualizedScroller>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PollVotedUserListModal;
